import styled from 'styled-components';
import { TableCell } from 'ui/tableCell';
import { noop } from 'utils/noop';
import { Apple } from 'ui/icons/devices/Apple';
import { Android } from 'ui/icons/devices/Android';
import { PositiveFill } from 'ui/icons/status/PositiveFill';
import { NegativeFillDiamond } from 'ui/icons/status/NegativeFillDiamond';
import { colors, spacing } from 'ui/theme';
import { LegacyDomainLabel } from './LegacyDomainLabel';
import { PathsTableOverflowMenu } from './PathsTableOverflowMenu';

const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.quarter};
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
`;

// type ColumnProps = {
//   onEnable: () => {}, // the handler for enabling a row
//   onEdit: () => {}, // the handler for editing a row
//   enabledForAndroid: boolean,
//   isDisabled: boolean,
// };

export const configurePathsColumns = ({
  enabledForAndroid = false,
  isDisabled = false,
  onEnable = noop,
  onEdit = noop,
}) => {
  return [
    {
      name: 'Destination domain',
      value: 'appDomain',
      align: 'flex-start',
      sortable: false,
      RowCell: ({ row }) => (
        <TableCell>
          <div>
            {row.appDomain || row.domain}
            {!row.appDomain && <LegacyDomainLabel />}
          </div>
        </TableCell>
      ),
    },
    {
      name: 'Platform',
      value: 'enabledForAndroid',
      align: 'flex-start',
      sortable: false,
      RowCell: () => (
        <TableCell>
          <div>
            <IconContainer>
              <Apple height={20} />
              {enabledForAndroid && <Android height={20} />}
            </IconContainer>
          </div>
        </TableCell>
      ),
    },
    {
      name: 'Status',
      value: 'enabledForProject',
      align: 'flex-start',
      sortable: false,
      RowCell: ({ row }) => {
        const enabled = row.enabledForProject && !isDisabled;
        return (
          <TableCell>
            {enabled ? (
              <FlexContainer>
                <PositiveFill color={colors.green100} />
                Enabled
              </FlexContainer>
            ) : (
              <FlexContainer>
                <NegativeFillDiamond color={colors.iconSubtle} />
                Disabled
              </FlexContainer>
            )}
          </TableCell>
        );
      },
    },
    {
      name: '',
      value: '',
      align: 'flex-end',
      sortable: false,
      RowCell: ({ row }) => (
        <PathsTableOverflowMenu
          isDisabled={isDisabled}
          onEdit={onEdit}
          onEnable={onEnable}
          row={row}
        />
      ),
    },
  ];
};
